import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { LibSubContractorsPaymentsDto  } from "@gtpl/shared-models/gtpl";

export class AllSubContractorsPaymentsResponseModel extends GlobalResponseObject {
    data?: LibSubContractorsPaymentsDto[];
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: LibSubContractorsPaymentsDto[]){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}

